import React from 'react';
import styled from 'astroturf/react';
import commaize from 'js/utils/commaize';
import { trackClick } from 'js/utils/trackClick';
import { Button } from 'js/design_system/Button';
import { useIsMobile } from './useIsMobile';
import PaceIcon from 'js/svg/colorless/pace.svg';
const Container = styled.div`
  display: flex;
  padding: 32px;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-xs-16);
  border-radius: 8px;
  background: var(--White, #fff);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  width: 80%;
  max-width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  text-align: center;
`;

const Title = styled.div`
  font-size: 28px;
  font-style: normal;
  line-height: 32px;
  color: #000;
  margin: 0;
  padding: 0;
`;

const Description = styled.div`
  color: #000;
  text-align: center;
  font-size: 16px;
  line-height: 18px;
`;

const SmallText = styled.div`
  color: #6d6d7d;
  text-align: center;
  font-size: 12px;
  line-height: 12px;
`;

type Props = {
  mentionsCount: number;
  annualPrice: string;
  onClickUpgrade: () => void;
};

const TasteOfMentionsUpsellCard = ({
  mentionsCount,
  annualPrice,
  onClickUpgrade,
}: Props) => {
  const isMobile = useIsMobile();

  const onClick = () => {
    trackClick({
      source: 'TasteOfMentionsUpsellCard',
      extra: {},
    });
    onClickUpgrade();
  };

  return (
    <Container>
      <PaceIcon
        svgProps={{
          width: '30px',
          height: '30px',
        }}
      />
      {isMobile ? (
        <Title>
          Unlock 2 more Mentions in 48 hours. Upgrade to see your{' '}
          {commaize(mentionsCount)} Mentions.
        </Title>
      ) : (
        <>
          <Title>Unlock 2 More Mentions in 48 Hours</Title>
          <Description>
            Want to see all of your {commaize(mentionsCount)} Mentions?
          </Description>
        </>
      )}
      <Button {...{ onClick }}>Upgrade to Premium</Button>
      <SmallText>Get full access to Premium for {annualPrice}/year</SmallText>
    </Container>
  );
};

export default TasteOfMentionsUpsellCard;
